/** True when a detail surface should show its full-page spinner instead of its content.
 *
 * Background refetches (e.g. the global RefreshFlag flipping after a status change) must NOT
 * unmount the already-mounted content: child components hold unsaved edits (splits, promo
 * selections, in-progress field text) in local state, and unmounting erases the user's work.
 * Only the initial load (no data yet) or navigating to a different record warrants the spinner.
 */
export function should_show_detail_spinner(
  loading: boolean,
  loaded_id: string | null | undefined,
  requested_id: string
): boolean {
  return loading && loaded_id !== requested_id
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("should_show_detail_spinner", () => {
    it("keeps content mounted during a background refetch of the same record", () => {
      expect(should_show_detail_spinner(true, "d1", "d1")).toBe(false)
    })

    it("shows the spinner while loading a different record", () => {
      expect(should_show_detail_spinner(true, "d1", "d2")).toBe(true)
    })

    it("shows the spinner on the initial load before any data arrives", () => {
      expect(should_show_detail_spinner(true, undefined, "d1")).toBe(true)
      expect(should_show_detail_spinner(true, null, "d1")).toBe(true)
    })

    it("does not show the spinner when nothing is loading", () => {
      expect(should_show_detail_spinner(false, "d1", "d2")).toBe(false)
      expect(should_show_detail_spinner(false, "d1", "d1")).toBe(false)
    })
  })
}
